import React, { useEffect } from 'react';

const TermsAndConditions = () => {
    const baseUrl = 'https://jermingo.com';
    
    useEffect(() => {
        // Update document title
        document.title = 'Terms and Conditions | Jermingo';
        
        // Update meta description
        let metaDesc = document.querySelector('meta[name="description"]');
        if (!metaDesc) {
            metaDesc = document.createElement('meta');
            metaDesc.setAttribute('name', 'description');
            document.head.appendChild(metaDesc);
        }
        metaDesc.setAttribute('content', 
            'Read Jermingo\'s Terms and Conditions. Learn about the terms of use, intellectual property rights, and limitations of liability for our travel blog website.'
        );
        
        // Add canonical URL
        let canonical = document.querySelector('link[rel="canonical"]');
        if (!canonical) {
            canonical = document.createElement('link');
            canonical.setAttribute('rel', 'canonical');
            document.head.appendChild(canonical);
        }
        canonical.setAttribute('href', `${baseUrl}/terms`);
    }, []);
    
    return (
        <div style={{ padding: '20px', fontFamily: 'Arial, sans-serif', lineHeight: '1.6' }}>
            <h1>Terms and Conditions</h1>
            <p>
                Welcome to Jermingo! By accessing or using our website, you agree to comply with and be bound by the 
                following terms and conditions. If you do not agree with these terms, please do not use our website.
            </p>

            <h2>1. Use of the Website</h2>
            <p>
                The content on this website is for informational purposes only. You may not use this website for any 
                unlawful or prohibited purpose. You agree to use the website in a manner that does not infringe on the 
                rights of others or restrict or inhibit their use and enjoyment of the website.
            </p>

            <h2>2. Intellectual Property</h2>
            <p>
                All content on this website, including text, images, graphics, and logos, is the property of Jermingo 
                or its content suppliers and is protected by copyright and other intellectual property laws. You may 
                not reproduce, distribute, or use any content without prior written permission.
            </p>

            <h2>3. Third-Party Services</h2>
            <p>
                Our website uses third-party services, including Google AdSense, to display advertisements. These 
                services may collect data about your browsing behavior to serve personalized ads. By using this website, 
                you consent to the use of such services and agree to their respective terms and policies.
            </p>

            <h2>4. Limitation of Liability</h2>
            <p>
                Jermingo is not responsible for any direct, indirect, incidental, or consequential damages arising from 
                your use of this website. We make no warranties or representations about the accuracy or completeness 
                of the content on this website.
            </p>

            <h2>5. External Links</h2>
            <p>
                This website may contain links to external websites. Jermingo is not responsible for the content, 
                privacy policies, or practices of these external websites. You access these links at your own risk.
            </p>

            <h2>6. Changes to the Terms</h2>
            <p>
                We reserve the right to update or modify these terms and conditions at any time without prior notice. 
                Your continued use of the website after any changes constitutes your acceptance of the updated terms.
            </p>

            <h2>7. Governing Law</h2>
            <p>
                These terms and conditions are governed by and construed in accordance with the laws of your jurisdiction. 
                Any disputes arising from these terms will be subject to the exclusive jurisdiction of the courts in your area.
            </p>

            <h2>8. Contact Us</h2>
            <p>
                If you have any questions about these terms and conditions, you can contact us at:
            </p>
            <ul>
                <li>Email: <a href="mailto:terms@jermingo.com">terms@jermingo.com</a></li>
            </ul>
        </div>
    );
};

export default TermsAndConditions;